import { createSectionForm } from "./sectionFormKit";

// Customer: components/sections/WholesalersBanner/WholesalersBanner.js
const WholesalersBanner = createSectionForm({
  icon: "store-2-line",
  title: "Wholesalers Banner",
  fields: [
    { name: "outline_heading", label: "Outline Heading", placeholder: "“Become a Wholesaler”" },
    { name: "title", label: "Title" },
    { name: "description", label: "Description", type: "richtext" },
    { name: "image", label: "Image", type: "media" },
  ],
});

export default WholesalersBanner;
